import React from 'react';
import { BorderButton } from '../../domain/order/Result/OrderResultButton';

import * as PATH from '../../lib/routes/path';
import { Flex } from '../common/atom/Layout';
import { Text } from '../common/atom/Text';

const ReviewPossibleListItem = ({
  id,
  categoryName,
  storageUri,
  itemName,
  createDateTime,
}) => {
  return (
    <Flex column alignItems="stretch" padding="1.25rem">
      <ReviewInfo
        storageUri={storageUri}
        itemName={itemName}
        createDateTime={createDateTime}
      />
      <Flex width="100%" padding="1.25rem 0 0">
        {categoryName === 'BABYFACE_BEFORE_BIRTH' && (
          <BorderButton link={`${PATH.REVIEW_WRITE}/before/${id}`} size={14}>
            출산 전 리뷰쓰고 1,000원 받기
          </BorderButton>
        )}
        {categoryName === 'BABYFACE_AFTER_BIRTH' && (
          <BorderButton
            link={`${PATH.REVIEW_WRITE}/after/${id}`}
            size={14}
            color="orangePink"
          >
            출산 후 비교사진 리뷰쓰기
          </BorderButton>
        )}
      </Flex>
    </Flex>
  );
};

export default ReviewPossibleListItem;

export const ReviewInfo = ({
  storageUri,
  itemName,
  createDateTime,
  rewrite,
}) => (
  <Flex>
    <img
      src={storageUri}
      alt="리뷰 작성 가능 썸네일"
      style={{
        borderRadius: '6px',
        width: '5rem',
        height: '5rem',
        objectFit: 'cover',
      }}
    />
    <Flex column alignItems="flex-start" padding="0 0 0 1.25rem" width="75%">
      <Text size={14}>베이비페이스</Text>
      <Text
        size={12}
        color="brownGrey"
        style={{ margin: '0.313rem 0', lineHeight: 1.5 }}
      >
        {itemName}
      </Text>
      <Text size={12} color="brownGrey">
        {rewrite ? '작성일' : '구매일'} : {createDateTime}
      </Text>
    </Flex>
  </Flex>
);
